import React from 'react';
import { Button } from 'antd';
import { DownloadOutlined, SaveOutlined } from '@ant-design/icons';
import { formatNumber, formatCurrency } from '../../services/estimationService';

const EstimationFooter = ({ totals, onExport, onSave }) => {
  const { grandTotal, perGF, perGV } = totals;

  return (
    <div
      className="cost-estimation-footer"
      style={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 24px'
      }}
    >
      {/* Totals Section */}
      <div
        style={{
          display: 'flex',
          gap: '32px',
          alignItems: 'center',
          flexWrap: 'wrap'
        }}
      >
        <div className="wz-total-group wz-total-main">
          <span className="wz-total-label">
            Total
          </span>
          <strong className="wz-total-value">
            {formatCurrency(grandTotal)}
          </strong>
        </div>

        <div className="wz-total-group">
          <span className="wz-total-label">
            CHF / m² GF
          </span>
          <strong className="wz-total-value">
            {formatNumber(perGF, 2)}
          </strong>
        </div>

        <div className="wz-total-group">
          <span className="wz-total-label">
            CHF / m³ GV
          </span>
          <strong className="wz-total-value">
            {formatNumber(perGV, 2)}
          </strong>
        </div>
      </div>

      {/* Action Buttons */}
      <div
        style={{
          display: 'flex',
          gap: '12px'
        }}
      >
        <Button
          icon={<DownloadOutlined />}
          onClick={onExport}
          size="large"
        >
          Export CSV
        </Button>

        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={onSave}
          size="large"
        >
          Schätzung speichern
        </Button>
      </div>
    </div>
  );
};

export default EstimationFooter;